<template>
    <nav id="pageHeader" class="navbar navbar-light fixed-top bg-primary">
        <slot></slot>
    </nav>
</template>

<script>
    export default {
        name: "PageHeader"
    }
</script>

<style>
    #app {
        margin-top: 70px;
    }
</style>
